import { render } from "./SettingsCardProfile.vue?vue&type=template&id=406a831e&scoped=true"
import script from "./SettingsCardProfile.vue?vue&type=script&lang=js"
export * from "./SettingsCardProfile.vue?vue&type=script&lang=js"

import "./SettingsCardProfile.vue?vue&type=style&index=0&id=406a831e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\oi\\Desktop\\TFC\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406a831e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QForm,QCard,QInput,QToggle,QBtn});
